<ng-container *transloco="let t">
  @if (page$ | async; as page) {
    <bgo-hero-cover
      [title]="page.cover.title | bgoReplaceProps: {regionName: page.region.regionName}"
      [description]="page.cover.subtitle | bgoReplaceProps: {regionName: page.region.regionName}"
      class="mt-xl h-layout block"
      [showTags]="true"
    >
      <bgo-hero-selling-point> </bgo-hero-selling-point>
      <cft-breadcrumbs [showBackButton]="false" [breadcrumbs]="page.breadcrumbs" />
      <bgo-hero-tags
        [heading]="t('craftsmenRegionDirectoryPage.featuredIndustries.title', {regionName: page.region.regionName})"
      >
        @for (industry of page.linkedIndustries; track $index) {
          <cft-chip colour="grey-lighter">
            <a class="cursor-pointer text-sm font-medium" [routerLink]="industryRegionPageLink(industry.slug)">
              {{ industry.label }}
            </a>
          </cft-chip>
        }
      </bgo-hero-tags>
      <bgo-hero-call-to-action-section>
        <cft-call-to-action [buttonStyle]="'hero'" callToActionStyle="button" [callToAction]="page.primaryCta" />
        <cft-call-to-action
          [buttonStyle]="'secondary'"
          callToActionStyle="button"
          [showIcon]="false"
          [callToAction]="page.secondaryCta"
        />
      </bgo-hero-call-to-action-section>
    </bgo-hero-cover>
    <div class="mt-3xl space-y-3xl md:space-y-20">
      @for (section of page.content; track $index; let last = $last) {
        @if (section.__type === 'ProDirectory') {
          <bgo-pro-directory-by-region-section [id]="$index | regionalDirectoryCssId" [region]="page.region" />
        } @else if (section.__type === 'ReviewSection') {
          <bgo-reviews-section
            [class.pb-4xl]="last"
            [reviewSection]="section"
            (buttonClicked)="navigateToAboutUsPage()"
            class="h-content-layout"
          />
        } @else if (section.__type === 'SupportSection') {
          <bgo-support-section [supportSection]="section" />
        } @else if (section.__type === 'KnowledgeSection') {
          <bgo-knowledge-section class="h-content-layout" [knowledgeSection]="section" />
        } @else if (section.__type === 'PresentationSection') {
          <bgo-presentation-section [section]="section" />
        } @else if (section.__type === 'ContentSection' && section.content.json) {
          <cft-content-section
            [title]="section.title"
            [plot]="section.plot"
            titleAlignment="left"
            class="h-content-layout"
            [class.pb-4xl]="last"
          >
            <bgo-rich-text [content]="section.content"></bgo-rich-text>
          </cft-content-section>
        } @else if (section.__type === 'SignupSection') {
          <bgo-lead-signup-section [section]="section"></bgo-lead-signup-section>
        } @else if (section.__type === 'ProMapSection') {
          <bgo-pro-map [title]="section.title" [region]="page.region" [sectionId]="section.id" />
        } @else if (section.__type === 'RelatedRegionSection') {
          @if (page.region.relatedRegions.length) {
            <bgo-related-items-section
              [title]="section.title | bgoReplaceProps: {regionName: page.region.regionName}"
              [relatedItems]="page.region.relatedRegions | mapRelatedRegions"
            />
          }
        } @else if (section.__type === 'VideoSection') {
          <bgo-video-section [section]="section" class="h-content-layout" [class.pb-4xl]="last" />
        }
      }
    </div>
    <bgo-sticky-bottom-navigation [class.sticky-navigation-show]="showStickyFooter" />
  }
</ng-container>
